import cn from 'classnames';
import { FC, ReactNode, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import gladCat from '@/shared/assets/images/cats/glad.png';
import { useMedia } from '@/shared/hooks';
import { AuthCard, Icon } from '@/shared/ui';

import { MFA_SUCCESS_HOLD_MS } from '../../config';

import styles from './MFAEnabledNotice.module.scss';

type MFAEnabledNoticeProps = {
  message: ReactNode;
  className?: string;
  /** Set when the notice is portalled over a page rather than being the page. */
  fixed?: boolean;
  onDone: () => void;
};

/** Held briefly so the confirmation is readable before the app takes over. */
export const MFAEnabledNotice: FC<MFAEnabledNoticeProps> = (props) => {
  const { message, className, fixed, onDone } = props;

  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  useEffect(() => {
    const timeout = setTimeout(onDone, MFA_SUCCESS_HOLD_MS);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <AuthCard
      fixed={fixed}
      variant="notice"
      className={className}
      dataSection="mfa-enabled-notice"
    >
      <h3 className={isMobile ? 'h5' : 'h3'}>
        <FormattedMessage
          id="mfa.verify.title"
          defaultMessage="Two-step verification"
        />
      </h3>

      <img
        src={gladCat}
        width={130}
        height={130}
        alt={formatMessage({
          id: 'imgAltText.gladCat',
          defaultMessage: 'Glad cat',
        })}
      />

      <h5 className={cn(styles.message, 'h5')}>{message}</h5>

      <Icon name="check" size={48} className={styles.icon} />
    </AuthCard>
  );
};
